/**
 * Mock event data for browser fallback.
 * Used only when API is unavailable (e.g. local dev without backend).
 */
import type { EventItem } from '../types';

export const MOCK_EVENTS: EventItem[] = [
  {
    id: 1,
    fence_id: 'gf001',
    fence: '東京駅八重洲口',
    type: 'zone_entry',
    date: '2026-03-31T09:12:00Z',
    date_from: null,
    date_to: null,
    verified: true,
    lat: 35.6812,
    lng: 139.7671,
    alt: 18.3,
    address: '東京都千代田区丸の内1丁目',
    vc_status: 'issued',
  },
  {
    id: 2,
    fence_id: 'gf001',
    fence: '東京駅八重洲口',
    type: 'zone_stay',
    date: '2026-03-31T09:12:00Z',
    date_from: '2026-03-31T09:12:00Z',
    date_to: '2026-03-31T10:28:00Z',
    verified: true,
    lat: 35.6812,
    lng: 139.7671,
    alt: 18.3,
    address: '東京都千代田区丸の内1丁目',
    vc_status: 'issued',
  },
  {
    id: 3,
    fence_id: 'gf001',
    fence: '東京駅八重洲口',
    type: 'zone_exit',
    date: '2026-03-31T10:30:00Z',
    date_from: null,
    date_to: null,
    verified: true,
    lat: 35.6812,
    lng: 139.7671,
    alt: 18.3,
    address: '東京都千代田区丸の内1丁目',
    vc_status: 'issued',
  },
  {
    id: 4,
    fence_id: 'gf002',
    fence: '大手町パークビル',
    type: 'zone_entry',
    date: '2026-03-31T10:35:00Z',
    date_from: null,
    date_to: null,
    verified: true,
    lat: 35.6862,
    lng: 139.7638,
    alt: 22.7,
    address: '東京都千代田区大手町1丁目',
    vc_status: 'issued',
  },
  {
    id: 5,
    fence_id: 'gf002',
    fence: '大手町パークビル',
    type: 'zone_stay',
    date: '2026-03-31T10:35:00Z',
    date_from: '2026-03-31T10:35:00Z',
    date_to: '2026-03-31T17:50:00Z',
    verified: true,
    lat: 35.6862,
    lng: 139.7638,
    alt: 22.7,
    address: '東京都千代田区大手町1丁目',
    vc_status: 'issued',
  },
  {
    id: 6,
    fence_id: 'gf003',
    fence: '鎌倉駅東口',
    type: 'zone_entry',
    date: '2026-03-30T08:00:00Z',
    date_from: null,
    date_to: null,
    verified: false,
    lat: 35.319,
    lng: 139.5506,
    alt: 19.6,
    address: '神奈川県鎌倉市御成町',
    vc_status: 'none',
  },
  {
    id: 7,
    fence_id: 'gf003',
    fence: '鎌倉駅東口',
    type: 'zone_exit',
    date: '2026-03-30T08:15:00Z',
    date_from: null,
    date_to: null,
    verified: true,
    lat: 35.319,
    lng: 139.5506,
    alt: 19.6,
    address: '神奈川県鎌倉市御成町',
    vc_status: 'issued',
  },
  {
    id: 8,
    fence_id: 'gf004',
    fence: '横浜ランドマークタワー',
    type: 'zone_entry',
    date: '2026-03-29T14:00:00Z',
    date_from: null,
    date_to: null,
    verified: true,
    lat: 35.4555,
    lng: 139.6318,
    alt: 156.2,
    address: '神奈川県横浜市西区みなとみらい2丁目',
    vc_status: 'issued',
  },
  {
    id: 9,
    fence_id: 'gf004',
    fence: '横浜ランドマークタワー',
    type: 'zone_stay',
    date: '2026-03-29T14:00:00Z',
    date_from: '2026-03-29T14:00:00Z',
    date_to: '2026-03-29T16:25:00Z',
    verified: true,
    lat: 35.4555,
    lng: 139.6318,
    alt: 156.2,
    address: '神奈川県横浜市西区みなとみらい2丁目',
    vc_status: 'issued',
  },
  {
    id: 10,
    fence_id: 'gf004',
    fence: '横浜ランドマークタワー',
    type: 'zone_exit',
    date: '2026-03-29T16:30:00Z',
    date_from: null,
    date_to: null,
    verified: true,
    lat: 35.4555,
    lng: 139.6318,
    alt: 156.2,
    address: '神奈川県横浜市西区みなとみらい2丁目',
    vc_status: 'issued',
  },
];
